<template>
  <div class="checkout-form width-full">
    <div class="bg-white px-4 pt-5 pb-4 sm:p-6">
      <GmapMap
        :center="{ lat: center.latitude, lng: center.longitude }"
        :zoom="13"
        :options="{
          mapTypeControl: false,
          streetViewControl: false
        }"
        map-type-id="terrain"
        class="map"
        @click="mark"
      >
        <google-marker v-if="marker" :position="marker"></google-marker>
      </GmapMap>
      <div
        class="px-4 py-4 sm:py-3 text-right sm:px-6 sm:flex sm:flex-row-reverse"
      >
        <b-button
          variant="primary"
          class="w-full sm:w-auto | mb-3 sm:mb-0 sm:mt-0 text-white"
          @click="accept"
        >
          <div>{{ $t("continue") }}</div>
        </b-button>

        <b-button
          variant="secondary"
          class="w-full sm:w-auto | sm:mr-3"
          @click="cancel"
        >
          <div>{{ $t("cancel") }}</div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import BButton from "../BButton";

export default {
  name: "CheckoutMap",

  components: {
    BButton
  },
  props: {
    closeMap: {
      type: Function,
      required: true
    },
    markerSelected: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: {},
      center: {
        latitude: 0,
        longitude: 0
      },
      marker: null
    };
  },
  computed: {},
  mounted() {
    this.marker = this.markerSelected;
    if (!this.marker) this.getLocation();
    else
      this.center = {
        latitude: this.marker.lat,
        longitude: this.marker.lng
      };
  },
  methods: {
    getLocation() {
      navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }) => {
          this.center = {
            latitude,
            longitude
          };
        }
      );
    },
    mark({ latLng: { lat, lng } }) {
      this.marker = {
        lat: lat(),
        lng: lng()
      };
    },
    cancel() {
      this.closeMap();
    },
    accept() {
      this.closeMap({ ...this.marker });
    }
  }
};
</script>
<style lang="scss" scoped>
.map {
  width: 100%;
  height: 500px;
}
</style>
